//?accountnumber=0
function gotoCartFromMyOrderPage(){
    const urlParams = new URLSearchParams(window.location.search);
    let accountnumber = urlParams.get('accountnumber');
    if ((accountnumber!= null) && (accountnumber.length) >= 1 && parseInt(accountnumber) >= 0){
      var latest_visit_url = getCookie("latest_visit_url");
      console.log(latest_visit_url);
      if (latest_visit_url.search("/cart") > 0){
        window.location.href="https://"+Shopify.shop+"/cart";  
      }
    } 
  }
  gotoCartFromMyOrderPage();